




































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { Utils } from '@/helper/utils';
import {
  CommunicationSearchRequest,
  MessageCountViewModel,
  MessageCountByRO,
  MessageCountByCallType,
  MessageCountByUser,
} from '@/models/fixedops/communicationdashboard';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { MetadataType } from '@/enums/enums';
import { Base } from '@/components/common/base';
import { messageService, userService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class CommunicationDashboardPage extends Base {
  public tenantId: number;
  public enterpriseId: number;
  public storeId: number;
  public selectedAdvisorEmail: any[] = [];
  public searchParameters: CommunicationSearchRequest = {
    selectedAdvisors: [],
    fromDate: '',
    toDate: '',
  };

  public communicationDashboard: MessageCountViewModel = {
    appointmentCount: '0',
    arCount: '0',
    dealCount: '0',
    roCount: '0',
  };

  public loading: boolean = false;
  public roLoading: boolean = false;
  public callTypeLoading: boolean = false;
  public pagedUserLoading: boolean = false;
  public calendarKey: number = 0;

  public advisors: any[] = [];
  public metadataType: string = MetadataType[MetadataType.RO];
  public searched: boolean = false;
  public searchedCallType: boolean = false;
  public searchedUser: boolean = false;
  public search: string = '';
  public paginations = new PaginationModel('roNumber', true, 5);
  public pagedRO: MessageCountByRO[] = [];

  public callTypePaginations = new PaginationModel('callType', true, 5);
  public pagedCallType: MessageCountByCallType[] = [];

  public userPaginations = new PaginationModel('email', false, 5);
  public pagedUser: MessageCountByUser[] = [];
  public isAdvisorLoading: boolean = false;
  public isCommunicatinDashboardLoading: boolean = false;
  public isMessageLoading: boolean = false;
  public defaultDates:any[]=[ 
  this.$moment().add(-7, 'days').format("YYYY-MM-DD"),
this.$moment().format("YYYY-MM-DD")
  ];

  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationROGrid.ro'
      ) as string,
      value: 'roNumber',
      align: 'left',
      sortable: true,
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationROGrid.count'
      ) as string,
      align: 'left',
      value: 'roCount',
      fieldType: 'template',
      title: 'Open details',
      template: (item) => {
        if (item.customerKey) {
          // tslint:disable-next-line:max-line-length
          return `<router-link icon :to="{ name: 'advisor.conversation.add', params: { type: '${this.metadataType}' }, query:{customerKey: '${item.customerKey}', recordKey: '${item.roNumber}' }}"
                    title = "Open details" >${item.roCount}</router-link>`;
        } else {
          return `<span>${item.roCount}</span>`;
        }
      },
      sortable: false,
    },
  ];

  public callTypeHeaders: VHeaders[] = [
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationCallTypeGrid.callType'
      ) as string,
      value: 'callType',
      align: 'left',
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : 'Uncategorized';
        },
      ],
      sortable: false,
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationCallTypeGrid.outboundCount'
      ) as string,
      align: 'left',
      value: 'outboundCount',
      sortable: false,
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationCallTypeGrid.inboundCount'
      ) as string,
      align: 'left',
      value: 'inboundCount',
      sortable: false,
    },
  ];

  public userHeaders: VHeaders[] = [
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationUserGrid.userName'
      ) as string,
      value: 'email',
      align: 'left',
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : 'Uncategorized';
        },
      ],
      sortable: false,
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationUserGrid.textOutboundCount'
      ) as string,
      align: 'left',
      value: 'textOutboundCount',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        if (item.email) {
          // tslint:disable-next-line:max-line-length
          return `<router-link icon :to="{ name: 'dashboard.text.dashboard', params: {viewmode: 'admintextdashboard' }, query:{advisorId: '${item.advisorId}' }}" title="See details">
                               ${item.textOutboundCount}
                        </router-link>`;
        } else {
          return `<span>${item.textOutboundCount}</span>`;
        }
      },
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationUserGrid.textInboundCount'
      ) as string,
      align: 'left',
      value: 'textInboundCount',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        if (item.email) {
          // tslint:disable-next-line:max-line-length
          return `<router-link icon :to="{ name: 'dashboard.text.dashboard', params: {viewmode: 'admintextdashboard' }, query:{advisorId: '${item.advisorId}' }}" title="See details">
                                  ${item.textInboundCount}
                            </router-link>`;
        } else {
          return `<span></span>`;
        }
      },
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationUserGrid.callInbound'
      ) as string,
      align: 'left',
      value: 'voiceInboundCount',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        if (item.email) {
          // tslint:disable-next-line:max-line-length
          return `<router-link icon :to="{ name: 'dashboard.text.dashboard', params: {viewmode: 'admintextdashboard' }, query:{advisorId: '${item.advisorId}' }}" title="See details">
                                  ${item.voiceInboundCount}
                            </router-link>`;
        } else {
          return `<span>${item.voiceInboundCount}</span>`;
        }
      },
    },
    {
      text: this.$parent.$t(
        'communicationDashbard.communicationUserGrid.callOutbound'
      ) as string,
      align: 'left',
      value: 'voiceOutboundCount',
      sortable: false,
      fieldType: 'template',
      template: (item) => {
        if (item.email) {
          // tslint:disable-next-line:max-line-length
          return `<router-link icon :to="{ name: 'dashboard.text.dashboard', params: {viewmode: 'admintextdashboard'}, query:{advisorId: '${item.advisorId}' }}" title="See details">
                                   ${item.voiceOutboundCount}
                            </router-link>`;
        } else {
          return `<span>${item.voiceOutboundCount}</span>`;
        }
      },
    },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'getMessages') {
      this.getMessages();
    }
    if (methodName === 'resetFilters') {
      this.resetFilters();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    //
    // let buttons: any = [];
    // buttons.push({'id':'0', 'type':'button', 'title':'Search', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Search', 'click':'getMessages', 'icon':'fas fa-search','requestProgress': true});
    // buttons.push({'id':'1', 'type':'button', 'title':'ResetFilters', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Reset Filters', 'click':'resetFilters', 'icon':'fas fa-redo'});
    //   this.$emit('updateToolBar', buttons);
  }

  public created(){
    this.setCommunicationDateRangeValues(this.defaultDates);
  }
  
  public mounted(): void {
    
    // activating tab
    if(this.$route.path == '/app/commdashboard'){
      this.$root.$emit('sidebar.layout.vue', 'commDashboard');
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    // this.getMessageCount();
    this.getadvisors();
    this.getMessages();
    // this.getMessagesByUser();
  }

  public async getadvisors(): Promise<void> {
    try {
      this.isAdvisorLoading = true;
      const advisors = await userService.getStoreActiveUsersByRoleAsync(
        'Advisor'
      );
      if (advisors.results.length) {
        this.advisors = advisors.results;
      } else {
        this.advisors = [];
      }
    } finally {
      this.isAdvisorLoading = false;
    }
  }

  public resetFilters() {
    this.isMessageLoading = true;
    this.searchParameters.selectedAdvisors = [];
    this.searchParameters.fromDate = this.subtractDaysFromPresent(7);
    this.searchParameters.toDate = this.presentDate();
    this.search = '';
    this.paginations.search = '';
    this.callTypePaginations.search = '';
    this.calendarKey++;
    this.getMessages();
  }

  public async getMessageCount(): Promise<void> {
    this.searchParameters.search = this.search;
    try {
      this.isCommunicatinDashboardLoading = true;
      this.communicationDashboard = await messageService.getMessageCountForDashBoard(
        this.searchParameters
      );
    } finally {
      this.isCommunicatinDashboardLoading = false;
      this.isMessageLoading = false;
      this.$emit('update:progress', this.isMessageLoading);
    }
  }

  public getMessages() {
    this.isMessageLoading = true;
    this.$emit('update:progress', this.isMessageLoading);
    this.getMessageCount();
    this.getMessagesByRO();
    this.getMessagesByCallType();
    this.getMessagesByUser();
  }

  public async getMessagesByRO(): Promise<void> {
    this.paginations.search = this.search;
    try {
      this.roLoading = true;
      const messages = await messageService.getROMessagesForDashBoard(
        this.paginations,
        this.searchParameters
      );
      this.pagedRO = messages.results;

      this.paginations.totalItems = messages.total;
    } finally {
      this.roLoading = false;
    }
  }

  public async getMessagesByCallType(): Promise<void> {
    this.callTypePaginations.search = this.search;
    try {
      this.callTypeLoading = true;
      const callTypeMessages = await messageService.getCallTypeMessagesForDashBoard(
        this.callTypePaginations,
        this.searchParameters
      );
      this.pagedCallType = callTypeMessages.results;

      this.callTypePaginations.totalItems = callTypeMessages.total;
    } finally {
      this.callTypeLoading = false;
    }
  }

  public async getMessagesByUser(): Promise<void> {
    this.userPaginations.search = this.search;
    try {
      this.pagedUserLoading = true;
      const userMessages = await messageService.getUserMessagesForDashBoard(
        this.userPaginations,
        this.searchParameters
      );
      this.pagedUser = userMessages.results;

      if (userMessages.total) {
        this.userPaginations.totalItems = userMessages.total;
      } else {
        this.userPaginations.totalItems = this.pagedUser.length;
      }
    } finally {
      this.pagedUserLoading = false;
    }
  }

  public updatePaging(paging: any) {
    this.paginations = paging;
    this.getMessagesByRO();
  }

  public updateCallTypePaging(paging: any) {
    this.callTypePaginations = paging;
    this.getMessagesByCallType();
  }

  public updateUserPaging(paging: any) {
    this.userPaginations = paging;
    this.getMessagesByUser();
  }
  public setCommunicationDateRangeValues(dates: any) {
    if (dates.length > 1) {
      this.searchParameters.fromDate = dates[0];
      this.searchParameters.toDate = dates[1];
    }

  }
}
